module.exports = __webpack_public_path__ + "img/child-2.6f0d6f1.jpg?v=1764327952164";